import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrderHistory } from '../../../models/OrderHistory';
import OrderService from '../../../services/OrderService';

@Component({
  selector: 'app-coin-usage-history',
  standalone: true,
  templateUrl: './coin-usage-history.component.html',
  styleUrls: ['./coin-usage-history.component.css'],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule
  ]
})
export class CoinUsageHistoryComponent implements OnChanges {
  @Input() orderId: string = '';
  
  orderHistory: OrderHistory[] = [];
  loading: boolean = false;
  error: string | null = null;
  displayedColumns: string[] = ['invoiceNo', 'stateText', 'coinAmount'];

  constructor(private orderService: OrderService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderId'] && this.orderId) {
      this.loadOrderHistory();
    }
  }

  loadOrderHistory(): void {
    if (!this.orderId) {
      return;
    }

    this.loading = true;
    this.error = null;

    this.orderService.getOrderHistory(this.orderId).subscribe({
      next: (data) => {
        this.orderHistory = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading order history:', err);
        this.error = 'Fehler beim Laden der Bestellhistorie';
        this.loading = false;
      }
    });
  }
}
